export type UserMenuSettingsBadge = "notifications-unread"

export type UserMenuSettingsItem = {
  key: string
  to: string
  icon: string
  labelKey: string
  badge?: UserMenuSettingsBadge
}

/** Пункты раздела «Настройки» в меню пользователя — добавляйте новые записи сюда. */
export const USER_MENU_SETTINGS_ITEMS: UserMenuSettingsItem[] = [
  {
    key: "notifications",
    to: "/profile?section=notifications",
    icon: "ri-notification-3-line",
    labelKey: "notifications.sidebar.item",
    badge: "notifications-unread",
  },
]
